export const apiQueryKeys = {
    read: () => ['api', 'read']
} as const;
